<template>
  <div>
    <div class="page-title">新增課題</div>
    <div class="page-box">
      <topicFrom ref="form" :formLabelAlign="formLabelAlign"></topicFrom>
      <div>請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="backIndexPage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addTopics } from "@/api/topics";
import topicFrom from "./components/topicFrom.vue";
export default {
  components: { topicFrom },
  data() {
    return {
      formLabelAlign: {
        number: null,
        lang: 0,
        name: null,
        scope: null,
        gradeId: null,
        grade: {
          id: null,
          name: null,
          price: null,
        },
        practises: [
         {
          id:null,
          number: null,
         }
        ],
        smallTest: {
          topicId: null,
          imageUrl: null,
          practises: [
            {
              randomNumber: null,
              number: null,
            },
          ],
        },
      },
    };
  },

  methods: {
    onSubmit() {
      // 驗證
      this.$refs.form.$refs.form.validate((valid) => { 
        if (valid) {
          this.addTopics();
        }
      });
      
    },
    addTopics() {
      addTopics(this.formLabelAlign).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
         this.$router.push({ name: 'topic' })
      });
    },
    backIndexPage() {
      this.$router.push({ path: '/topic' })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>